export const userGuidesIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#resources-title',
    intro: 'User Guides is where you can access and download all of the WordFlight User Guides, the WordFlight Scope and Sequence, and the WordFlight quick guides. These documents provide full information about WordFlight.'
  },
  {
    element: '.kb-list:nth-of-type(2)',
    intro: 'Click on any user guide to download it and read more about the specific WordFlight information it covers.',
    position: 'left',
  },
  {
    element: '.kb-list:nth-of-type(1)',
    intro: 'Click on any of the additional resources to learn more about WordFlight.',
  }
];
